import React from "react";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import DataGrid, { Column, Scrolling, FilterRow, Grouping } from "devextreme-react/data-grid";
import * as Constants from "../../../../consts/Constants.js";
import service from '../../../../plas/services/shifter/service';
import alerter from "../../../alerts/alerter"


export default function AttendeesList({
  shift,
  onCancel,
  fullWidth
}) {

  const [reservations, setReservations] = React.useState([]);
  const [attendees, setAttendees] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    loadReservations()
  }, []);

  const loadReservations = () => {
    setLoading(true);
    service.api.reservations.getPage(0, 32767, null, [0], shift.id, "+id", (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
        if (onCancel)
          onCancel()
      } else {
        setReservations(response.result.data);
        setLoading(false);
      }
    });
  }

  React.useEffect(() => {
    prepareAttendees(reservations)
  }, [reservations]);

  const prepareAttendees = (reservations) => {
    let list = [];
    reservations.forEach((reservation) => {
      list = list.concat(reservation.attendees);
    });
    setAttendees(list);
  }

  return(
    <Grid container>
      <Grid item xs={12} style={{ textAlign: "center"}}>
        { loading ? (
          <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
        ):(
          <Grid container spacing={2}>
            <Grid item xs={false} md={ fullWidth ? false : 2} />
              <Grid item xs={12} md={ fullWidth ? 12 : 8} >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <DataGrid
                      id="gridContainer"
                      dataSource={attendees}

                      export={{
                        enabled: false,
                        fileName: "Asistentes",
                        allowExportSelectedData: false
                      }}
                      onToolbarPreparing={(e) => {
                        e.toolbarOptions.items.push({
                          location: 'before',
                            template: function() {
                              return `<div> 
                                <h4>Asistentes</h4>
                              </div>`
                          }
                        });
                        e.toolbarOptions.items.push({
                          widget: 'dxButton',
                          showText: 'always',
                          options: {
                              icon: 'download',
                              onClick: function () {
                                  e.component.exportToExcel(false);
                              }
                          },
                          location: 'after'
                        });
                        e.toolbarOptions.items.push({
                          widget: 'dxButton',
                          showText: 'always',
                          options: {
                              icon: 'refresh',
                              onClick: function () {
                                  loadReservations();
                              }
                          },
                          location: 'after'
                        });
                        e.toolbarOptions.items.push({
                          widget: 'dxButton',
                          showText: 'always',
                          options: {
                              icon: 'clear',
                              text: 'Cerrar',
                              onClick: function () {
                                  onCancel();
                              }
                          },
                          location: 'after'
                        });
                      }}>
                      <FilterRow visible={true} />
                      <Grouping autoExpandAll={true} />
                        <Column dataType="text" filterOperations={["startswith"]} width={90} customizeText={(cellInfo) => `#${cellInfo.value}`} caption="Reserva" dataField="requestId" sortOrder="asc" />
                        <Column dataType="text" filterOperations={["startswith"]} width={120} caption="DNI" dataField="dni" />
                        <Column dataType="text" filterOperations={["contains"]} caption="Nombre" dataField="name" />
                        <Column dataType="text" filterOperations={["contains"]} caption="Apellido" dataField="lastName" />
                      <Scrolling mode="infinite" />
                    </DataGrid>
                  </Grid>
                </Grid>
              </Grid>
            <Grid item xs={false} md={ fullWidth ? false : 2} />
          </Grid>
        )}
      </Grid>
    </Grid>
  )

}
